module.exports = __webpack_public_path__ + "static/img/pay_qrpay_qr@3x.ef1904d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pay_qrpay_qr@3x.png
// module id = 4FsZ
// module chunks = 1